import {
  SET_TOKEN,
  SET_NICKNAME,
  SET_LEVEL,
  SET_USERNAME,
  SET_ADDRESS_LIST,
  SET_BALANCE,
  SET_INTEGRAL
} from "../mutation-types"

import api from '@/api'
import Vue from "vue"
import storage from "../../utils/storage"

const state = {
  token: '',
  username: '',
  nickname: '',
  level: '',
  balance: 0,
  integral: 0,
  addressList: [],

}
const mutations = {

  [SET_TOKEN](state, token) {
    // state.token = token
    Vue.set(state, 'token', token)
  },
  [SET_NICKNAME](state, nickname) {
    // state.nickname = nickname
    Vue.set(state, 'nickname', nickname)
  },
  [SET_LEVEL](state, level) {
    // state.level = level
    Vue.set(state, 'level', level)
  },
  [SET_USERNAME](state, username) {
    // state.username = username
    Vue.set(state, 'username', username)
  },
  [SET_ADDRESS_LIST](state, addressList) {
    Vue.set(state, 'addressList', addressList)
  },
  [SET_BALANCE](state, balance) {
    Vue.set(state, 'balance', balance)
  },
  [SET_INTEGRAL](state, integral) {
    Vue.set(state, 'integral', integral)
  }
}
const actions = {
  register({ commit, rootState, dispatch }, data) {
    const { account, password } = data
    return new Promise((resolve, reject) => {
      api.user.register(data).then(res => {
        const { result: { token, nickname, level } } = res
        storage.set('token', token)
        storage.set('nickname', nickname)
        storage.set('level', level)
        storage.set('account', account)
        commit(SET_TOKEN, token)
        commit(SET_NICKNAME, nickname)
        commit(SET_LEVEL, level)
        commit(SET_USERNAME, account)
        if (rootState.cart.shoppingCart.length > 0) {
          dispatch("cart/updateCart", null, { root: true });

        } else {
          dispatch("cart/initShoppingCart", null, { root: true });

        }
        resolve(true)

      }).catch(err => reject(err))
    })
  },
  login({ commit, rootState, dispatch }, userInfo) {
    const { account, password } = userInfo
    return new Promise((resolve, reject) => {
      api.user.login({ account: account.trim(), password: password }).then(res => {
        const { result: { token, nickname, level } } = res
        storage.set('token', token)
        storage.set('nickname', nickname)
        storage.set('level', level)
        storage.set('account', account)

        commit(SET_TOKEN, token)
        commit(SET_NICKNAME, nickname)
        commit(SET_LEVEL, level)
        commit(SET_USERNAME, account)
        if (rootState.cart.shoppingCart.length > 0) {
          dispatch("cart/updateCart", null, { root: true });

        } else {
          dispatch("cart/initShoppingCart", null, { root: true });

        }
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  refreshUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      api.user.userInfo().then(res => {
        let { result: { balance, integral } } = res
        commit(SET_BALANCE, balance)
        commit(SET_INTEGRAL, integral)
        resolve(true)
      }).catch(err => reject(err))
    })

  },
  logout({ commit, dispatch }) {
    //清理user.js
    storage.remove('token')
    storage.remove('nickname')
    storage.remove('level')
    storage.remove('account')
    commit(SET_TOKEN, '')
    commit(SET_NICKNAME, '')
    commit(SET_LEVEL, '')
    commit(SET_USERNAME, '')
    //清理cart.js
    dispatch('cart/cleanShoppingCart', {}, { root: true })
    dispatch('cart/cleanPromotionsShoppingCart', {}, { root: true })
    //清理order.js
    dispatch('order/cleanOrderParams', {}, { root: true })

    dispatch('user/cleanAddress', {}, { root: true })
  },

  initUser({ commit }) {
    let token = storage.get('token')
    let nickname = storage.get('nickname')
    let level = storage.get('level')
    let account = storage.get('account')
    commit(SET_TOKEN, token)
    commit(SET_NICKNAME, nickname)
    commit(SET_LEVEL, level)
    commit(SET_USERNAME, account)
  },




  /**
   * 查询所有地址
   * @param {*} param0
   */
  setAllAddress({ commit, state, rootGetters }) {
    // console.log(rootGetters)
    if (rootGetters.isLogin) {
      api.user.selAddress({}, {}).then(
        res => {
          const { result: { list } } = res
          list.forEach(ads => ads.check = false)
          if (list.length > 0) {
            list[0].check = true;
          }
          commit(SET_ADDRESS_LIST, list)
        }
      )
    }
  },

  /**
   * 修改选中的addresss
   * @param {*} param0
   * @param {*} addressId
   */
  changeCheckAddress({ commit, state }, addressId) {
    return new Promise((resolve, reject) => {
      let address = {}
      let addressList = state.addressList
      addressList.forEach(ads => {
        ads.check = ads.addressId === addressId
        if (ads.check) {
          address = ads
        }
      })
      commit(SET_ADDRESS_LIST, addressList)
      resolve(address)
    })

  },
  /**
   * 添加地址逻辑
   * 追加state.addressList 并清空选中状态
   * @param {*} param0
   * @param {*} address
   */
  addAddress({ commit, state }, addAddress) {
    return new Promise((resolve, reject) => {
      api.user.addAddress(addAddress, {}).then(
        res => {
          let addressRequest = res.result;
          //确认是否新增成功
          if (addressRequest.addressId) {
            addressRequest.check = true;
            state.addressList.forEach(ads => {
              ads.check = false;
            });
            state.addressList.unshift(addressRequest)
            commit(SET_ADDRESS_LIST, state.addressList)
            resolve(addressRequest)
          } else {
            resolve()
          }
        }).catch(err => reject(err))
    })

  },
  /**
   * 修改地址逻辑
   * @param {*} param0
   * @param {*} editAddress
   */
  editAddress({ commit, state }, editAddress) {
    return new Promise((resolve, reject) => {
      api.user.editAddress(editAddress, {}).then(
        res => {
          let addressRequest = res.result;
          //确认是否新增成功
          if (addressRequest.addressId) {
            addressRequest.check = true;
            let addressList = state.addressList
            addressList.forEach((ads, i, arr) => {
              ads.check = false;
              if (ads.addressId === editAddress.addressId) {
                ads.check = true;
                arr[i] = Object.assign(ads, editAddress)
              }
            });
            commit(SET_ADDRESS_LIST, addressList)
          }
          resolve()
        }).catch(err => reject(err))
    })
  },
  /**
   * 删除地址信息
   * @param {*} param0
   */
  removeAddress({ commit, state }, addressId) {

    return new Promise((resolve, reject) => {
      let idx;
      let addressList = state.addressList
      addressList.filter((e, i, arr) => {
        e.addressId = addressId
        idx = i
      })
      api.user.removeAddress(addressId).then(
        res => {
          addressList.splice(idx)
          commit(SET_ADDRESS_LIST, addressList)
          resolve(res.result)
        }
      ).catch(err => reject(err))
    })
  },
  setDefaultAddress({ commit, state }, addressId) {
    api.user.setDefaultAddress({ addressId }).then(
      res => { }).catch(err => err);
  },
  /**
   * 清理地址信息
   * @param {*} param0
   */
  cleanAddress({ commit }) {
    commit(SET_ADDRESS_LIST, [])
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js